module.exports = __webpack_public_path__ + "img/hrm-judith.1a8d929.png";